import { ReportsAnalytics } from "@/components/ReportsAnalytics";
import { useNavigate } from "react-router-dom";

export const ReportsPage = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");
  return <ReportsAnalytics onBack={handleBack} />;
};
